module.exports = __webpack_public_path__ + "img/expired_bkg.d61d00f5.png";